import { InternalCreateApiOptions } from './buildCreateApi';
import { createStore, $INTERNALS } from './createStore';

import type { BaseQueryFn, EndpointDefinitions } from './rtk-query-types';

/** Параметры функции `createApi` */
interface CreateApiOptions<
    ApiName extends string,
    BaseQuery extends BaseQueryFn,
    Definitions extends EndpointDefinitions,
    TagTypes extends string = never,
> extends Omit<InternalCreateApiOptions<BaseQuery, Definitions, string, TagTypes>, 'name'> {
    /** Уникальное название API */
    name: ApiName;
}

/** Создает RTK Query API для работы с серверными данными */
export function createApi<
    ApiName extends string,
    BaseQuery extends BaseQueryFn,
    Definitions extends EndpointDefinitions,
    TagTypes extends string = never,
>({ name, ...options }: CreateApiOptions<ApiName, BaseQuery, Definitions, TagTypes>) {
    const store = createStore(name);
    return store[$INTERNALS].createApi({ name: 'slice', ...options });
}
